if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class AddToCart extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form[action$="/cart/add"]');
        this.productIdInput = this.form.querySelector("[name=id]");
        this.productIdInput.disabled = false; // Повернуто з оригіналу
        this.submitBtn = this.querySelector('button[name="add"]');
        this.form.addEventListener("submit", this.formSubmit.bind(this));
      }

      formSubmit(evt) {
        evt.preventDefault();
        const soldOutWrapper = document.querySelector(
          ".wrapper__sold-out-info"
        );
        const emailInput = document.querySelector(
          'input[name="sold_out_email"]'
        );

        let isSoldOutMode = false;
        if (
          soldOutWrapper &&
          emailInput &&
          window.getComputedStyle(soldOutWrapper).display !== "none"
        ) {
          isSoldOutMode = true;
        }

        if (isSoldOutMode) {
          this.submitToKlaviyoNewApi(emailInput.value);
        } else {
          this.addToCart();
        }
      }

      submitToKlaviyoNewApi(email) {
        const variantId = this.productIdInput.value;
        const apiKey = this.submitBtn.getAttribute("data-klaviyo-key");

        if (!apiKey || apiKey.includes("YOUR_PUBLIC")) {
          console.error(
            "Add your Klaviyo Key to the button data-klaviyo-key attribute"
          );
          return;
        }
        if (!email || !email.includes("@")) {
          this.variantError("Please enter a valid email address.");
          const emailInputEl = document.querySelector(
            'input[name="sold_out_email"]'
          );
          if (emailInputEl) {
            emailInputEl.value = "";
          }
          return;
        }

        this.submitBtn.classList.add("loading");

        const requestData = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };

        const requestConfig = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(requestData),
        };

        fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${apiKey}`,
          requestConfig
        )
          .then((response) => {
            if (response.ok) {
              const soldOutWrapper = document.querySelector(
                ".wrapper__sold-out-info"
              );
              if (soldOutWrapper) {
                const emailInputEl = document.querySelector(
                  'input[name="sold_out_email"]'
                );
                if (emailInputEl) {
                  emailInputEl.style.display = "none";
                }

                const btnToHide = this.querySelector(".wrapper-payment-btns");
                if (btnToHide) {
                  btnToHide.style.setProperty("display", "none", "important");
                }
                const soldOutText =
                  soldOutWrapper.querySelector(".sold-out__text");

                if (soldOutText) {
                  soldOutText.innerText =
                    "We'll notify you when this item is back in stock!";

                  soldOutText.classList.add("mb-18");
                }
              }
            } else {
              return response.json().then((err) => {
                throw new Error(
                  err.errors && err.errors[0]
                    ? err.errors[0].detail
                    : "Error subscribing"
                );
              });
            }
          })
          .catch((error) => {
            console.error(error);
            this.variantError(
              "Something went wrong or you are already subscribed."
            );
          })
          .finally(() => {
            this.submitBtn.classList.remove("loading");
          });
      }

      addToCart() {
        if (this.productIdInput.value == "") {
          this.variantError();
          return;
        }

        if (this.querySelector(".error-message")) {
          this.querySelector(".error-message").remove();
        }
        this.removeErrorsBlock();

        this.submitBtn.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then((r) => {
            if (r.status) this.errorMessage(r);
            else this.succses();
          })
          .catch((e) => {
            console.log(e);
            this.submitBtn.classList.remove("loading");
          });
      }

      errorMessage(resp) {
        this.errorPopup(resp.description);
        this.submitBtn.classList.remove("loading");
      }

      succses() {
        this.submitBtn.classList.remove("loading");
        if (typeof updateCartCount === "function") updateCartCount();
        if (typeof updateCartNotification === "function")
          updateCartNotification(this.productIdInput.value);
      }

      variantError(text = null) {
        this.errorPopup(text || window.translation.variant_error);
      }

      removeErrorsBlock() {}

      errorPopup(text) {
        let alertPopup = document.querySelector(".js-productAlert-modal");
        const bodyEl = document.querySelector("html");
        if (alertPopup) {
          if (alertPopup.querySelector("[data-error-text]"))
            alertPopup.querySelector("[data-error-text]").innerHTML = text;

          if (!alertPopup.classList.contains("show")) {
            bodyEl.classList.add("show-modal");
            document
              .querySelectorAll(".wrapper-modal")
              .forEach((m) => m.classList.remove("show"));
            alertPopup.classList.add("show");
            if (alertPopup.classList.contains("modal-overlay"))
              bodyEl.classList.add("show-modal-overlay");
          }
        } else {
          alert(text);
        }
      }
    }
  );
}
